import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  style: {"height":"80px","width":"80px","border-radius":"80px","background-color":"rgba(249, 177, 42, 0.32)"},
  class: "elevation-0 d-flex align-center justify-center"
}
const _hoisted_2 = {
  style: {"height":"80px","width":"80px","border-radius":"80px","background-color":"rgba(249, 177, 42, 0.32)"},
  class: "elevation-0 d-flex align-center justify-center"
}
const _hoisted_3 = {
  class: "font-italic",
  style: {"font-size":"0.65em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.windowStep,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.windowStep) = $event)),
    touchless: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, { value: 'default' }, {
        default: _withCtx(() => [
          (_ctx.type === 'sendingMail')
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "d-flex align-center justify-center",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createElementVNode("p", null, " Les adresses Gmail et Outlook/Microsoft ne sont pas prises en charge, mais arrivent bientôt sur bobbee ", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_ctx.type === 'accountingMail' || _ctx.type === 'documentFromMail')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  class: "d-flex align-center justify-center",
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "x-small",
                          color: "error"
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("$fa-exclamation-triangle")
                          ])),
                          _: 1
                        }),
                        _cache[14] || (_cache[14] = _createTextVNode(" Les adresses Outlook/Microsoft sont temporairement bloquées, mais reviennent bientôt sur bobbee "))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          _createVNode(_component_v_container, {
            fluid: "",
            "grid-list-md": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "pa-1"
              }, {
                default: _withCtx(() => [
                  (_ctx.type !== 'sendingMail')
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, {
                            class: "pa-3 mx-5 elevation-0 rounded-xl",
                            style: {"border":"1px #ededed solid","background-color":"#fff","overflow":"hidden"},
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.connectToGmail()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex justify-center py-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_1, [
                                        _createVNode(_component_v_img, {
                                          contain: "",
                                          height: "40px",
                                          src: _ctx.GMailImg
                                        }, null, 8, ["src"])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex justify-center text-center text-subtitle-1"
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode(" Ajouter une adresse Gmail ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "pa-3 mx-5 elevation-0 rounded-xl",
                        style: {"border":"1px #ededed solid","background-color":"#fff","overflow":"hidden"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.windowStep = 'notGmailVue'))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex justify-center py-2"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_icon, {
                                      icon: "$fa-envelope",
                                      color: "primary",
                                      size: "x-large"
                                    })
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex justify-center text-center text-subtitle-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.displayTextForAddingOtherEmailAddress), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, { value: 'notGmailVue' }, {
        default: _withCtx(() => [
          (_ctx.type === 'sendingMail')
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "d-flex align-center justify-center",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createElementVNode("p", null, " Les adresses Gmail ne sont pas prises en charge, mais arrivent bientôt sur bobbee ", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, {
            class: "default_card large mx-0 pa-2",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref: "form",
                modelValue: _ctx.valid,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.valid) = $event)),
                "update:modelValue": _ctx.$emit('displayValid', _ctx.valid)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex pr-1",
                        cols: "12",
                        sm: "7"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                            type: "text",
                            label: "Email",
                            "hide-details": false,
                            rules: [_ctx.rules.isEmail, _ctx.rules.notAlreadyUsedMail, _ctx.rules.notEmpty],
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adaptHostToEmail()))
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "d-flex pr-1",
                        cols: "12",
                        sm: "5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_combobox_filled, {
                            modelValue: _ctx.host,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.host) = $event)),
                            items: _ctx.type === 'sendingMail' ? _ctx.listHostsSmtp : _ctx.listHostsImap,
                            label: _ctx.type === 'sendingMail' ? 'Serveur SMTP' : 'Serveur IMAP',
                            rules: [_ctx.rules.notEmpty],
                            disabled: _ctx.hostDisabled,
                            density: "compact"
                          }, null, 8, ["modelValue", "items", "label", "rules", "disabled"]),
                          _createVNode(_component_v_btn_icon, {
                            icon: "$oss-edit",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hostDisabled = !_ctx.hostDisabled))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "d-flex pr-1",
                        cols: "12",
                        sm: "7"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.password,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.password) = $event)),
                            "append-inner-icon": "$oss-eye",
                            type: _ctx.show ? 'text' : 'password',
                            label: "Mot de Passe",
                            rules: [_ctx.rules.notEmpty],
                            "hide-details": false,
                            "onClick:appendInner": _cache[7] || (_cache[7] = ($event: any) => (_ctx.show = !_ctx.show))
                          }, null, 8, ["modelValue", "type", "rules"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "d-flex pr-1",
                        cols: "12",
                        sm: "5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field_filled, {
                            modelValue: _ctx.port,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.port) = $event)),
                            type: "text",
                            label: "Port",
                            rules: [_ctx.rules.notEmpty],
                            disabled: _ctx.portDisabled,
                            "hide-details": false
                          }, null, 8, ["modelValue", "rules", "disabled"]),
                          _createVNode(_component_v_btn_icon, {
                            icon: "$oss-edit",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.portDisabled = !_ctx.portDisabled))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "update:modelValue"]),
              (_ctx.errorCredentials)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    border: "start",
                    color: "red",
                    type: "error",
                    variant: "text"
                  }, {
                    default: _withCtx(() => [
                      _cache[17] || (_cache[17] = _createElementVNode("div", null, "Adresse mail, mot de passe ou serveur IMAP incorrect", -1)),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatedSpecialErrorMessage), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.errorCredentials2)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    border: "start",
                    color: "red",
                    type: "error",
                    variant: "text"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode(" Adresse mail incorrecte ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}